import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { PatientimmunicationData, PatientimmunicationMst } from '../../../interfaces/masters/patientimmunication';
import { PatientimmunicationApi } from '../api/patientimmunication.api';

@Injectable()
export class PatientimmuicationService extends PatientimmunicationData {

  constructor(private api: PatientimmunicationApi) {
    super();    
  }
  list(url: string): Observable<PatientimmunicationMst[]> {
    return this.api.list(url);
  }
  getById(url:string): Observable<PatientimmunicationMst>{
      return this.api.getById(url); 
  }
  create(url: string, data:PatientimmunicationMst): Observable<PatientimmunicationMst> {
    return this.api.add(url,data);
  }
  update(url: string, data:PatientimmunicationMst): Observable<PatientimmunicationMst> {
    return this.api.update(url,data);
  }  
  delete(url: string): Observable<boolean> { 
    return this.api.delete(url);
  } 
}
